import {apiFuns} from "sw-hic"
let {genStandard} = apiFuns
const api = {
  Surgery: genStandard("surgery", "/api/ip"),
  hospitalization: genStandard("hospitalization", "/api/ip"),
}
export default api;